/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import BobModal from '../../../components/BobModal';
import InspectionReport from '../../../components/InspectionReport';
import moment from 'moment';
import {savePDF} from '@progress/kendo-react-pdf';
import classes from './ReportPreviewModal.module.css';

const AnnouncementModal = ({
    close,
    open,
    targetReport,
    title,
    ...props
}) => {
    const [ reportMonth, setReportMonth ] = useState();
    const [reportYear, setReportYear] = useState();

    const pdf = useRef();

    useEffect(() => {
        const target = targetReport;
        if (target) {
            const month = moment(target.reportData.TargetDate.Start).utc().format('MMMM');
            const year = moment(target.reportData.TargetDate.Start).utc().format('YYYY');

            setReportMonth(month);
            setReportYear(year);
        }
    }, []);

    const reportPageTemplate = props => {
        return (
            <div className={classes.Footer}>
                <div className={classes.NoPriorityFooter}><span className={classes.NoPriority} />&nbsp;-&nbsp;No Issues</div>
                <div className={classes.LowPriorityFooter}><span className={classes.LowPriority} />&nbsp;-&nbsp;Low Priority</div>
                <div className={classes.MediumPriorityFooter}><span className={classes.MediumPriority} />&nbsp;-&nbsp;Medium Priority</div>
                <div className={classes.HighPriorityFooter}><span className={classes.HighPriority} />&nbsp;-&nbsp;High Priority</div>
                <div className={classes.ScoreCalucationDescription}><span>With Building Optimization Broker's default scoring, each equipment or system starts with a score of 100%. As rules are evaluated, that score is decremented based on the priority of faults occurring on a piece of equipment or system. Low Priority faults impact an equipment or system's score less than a Medium or High Priority fault. </span></div>
            </div>
        );
    };

    const handleDownload = () => {
        // removes the footer from the preview page since it will be created on each page
        const lastChild = pdf.current.lastChild;
        let report = pdf.current;
        report.childNodes.forEach((n) => {
            if (n === lastChild) {
                report.removeChild(n);
            }
        }); 

        savePDF(report, {
            paperSize:      'Letter',
            scale:          0.7,
            margin:         {top: 30, left: 0, right: 60, bottom: 100},
            forcePageBreak: '.page-break',
            fileName:       `${targetReport.siteName}_InspectionReport_${reportMonth}_${reportYear}`,
            pageTemplate:   reportPageTemplate
        }, () => {
            close();
        });
    };

    const handleClose = () => {
        close();
    };

    return (
        <BobModal
            onCancel={handleClose}
            onClose={handleClose}
            rootClass={'reporting-modal'}
            open={open}
            cancelText={'Close'}
            confirmText={'Download'}
            onConfirm={handleDownload}
            applyHidden={false}
            isRemoveFooter={false}
            title={'Preview Inspection Report'}
        >
            <InspectionReport report={targetReport} ref={pdf} />
        </BobModal>
    );
};

AnnouncementModal.propTypes = {

};

const mapStateToProps = state => {
    return {

    };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementModal);
